import { SelectedSeatData } from '@3ddv/igsu-models/definitions/seat.model';
import { SectionModel } from '@3ddv/igsu-models/definitions/section.model';
import { TdcTransactionModel, TransactionDataToDisplay } from '@3ddv/utils-igsu';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { cardPaymentMethodPayload } from 'braintree-web-drop-in';

@Injectable({ providedIn: 'root' })
export class PaymentAPI {
  private _http = inject(HttpClient);

  public createPayment = (createPaymentParameters: {
    returnedTicketsData: Record<string, any>[];
    sectionData: SectionModel;
    selectedSeats: SelectedSeatData[];
    oktaId: string | null;
    hasSeats: boolean;
    priceScaleId?: string;
    eventId?: number;
  }) => {
    const endpoint = '/transactions';

    return this._http.post<TransactionDataToDisplay>(endpoint, createPaymentParameters);
  };

  public cancelPayment = (transaction: TdcTransactionModel) => {
    const endpoint = '/transactions/' + transaction.transactionId;
    return this._http.delete(endpoint, { body: transaction });
  };

  public getBraintreeToken = (cartId: number) => {
    const endpoint = `/transactions/${cartId}/braintree-token`;
    return this._http.get<string>(endpoint);
  };

  public getStripeToken = (cartId: number) => {
    const endpoint = `/transactions/${cartId}/stripe-token`;
    return this._http.get<string>(endpoint);
  };

  public checkout = ({
    paymentProvider,
    cartId,
    transactionId,
    token,
    cardType,
    externalPaymentMethodId,
  }: {
    paymentProvider: 'braintree' | 'stripe';
    cartId: number;
    transactionId: string;
    token: string;
    cardType?: cardPaymentMethodPayload['details']['cardType'];
    externalPaymentMethodId?: number;
  }) => {
    const endpoint = `/transactions/${cartId}/checkout`;
    // TODO: type this when it is decided what to return from checkout
    return this._http.post<any>(endpoint, {
      paymentProvider,
      token,
      transactionId,
      cardType,
      externalPaymentMethodId,
    });
  };
}
